// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__39Izz","title":"card_title__2bcL6","inActive":"card_inActive__3rtqV"};